import i18n from '@/plugins/i18n';
export const forms = [
    {
        type: 'multiInput',
        name: 'dealerForm',
        default: [{is_technical_service: false, company_id: null}],
        title: 'Firma / Bayi Bilgileri',
        modal: ['company_info'],
        data:['company_info'],
        inputs:[
            {
                type: 'select',
                name: 'company_id',
                title: i18n.t('customer.wizzard.dealer'),
                rules: {required: true},
                modal: ['company_id'],
                data: ['company_id'],
                options: {
                    data: [],
                    label: 'name',
                    track: 'id'
                },
                additionalButton: false,
                checkBox: false
            },
            {
                type: 'radio',
                name: 'is_technical_service',
                title: i18n.t('customer.wizzard.dealerType'),
                rules: {required: true},
                default: false,
                options: {
                    type: 'locale',
                    data: [
                        {text: i18n.t('customer.wizzard.dealer'), value: false},
                        {text: i18n.t('customer.wizzard.technicalService'), value: true},
                    ],
                },
                modal: ['is_technical_service'],
                data: ['is_technical_service'],
                additionalButton: false,
                checkBox: false
            },
        ],
        additionalButton: false,
        checkBox: false
    },
]
export default forms;


// WEBPACK FOOTER //
// ./src/pages/General/Customer/forms/dealerForm.js